export const buildInventorySourceGroupKey = (inventorySourceGroup) => {
  return `${inventorySourceGroup.inventorySourceType}-${inventorySourceGroup?.sellerInventoryPartnerId || 0}`;
};

export const buildInventorySourceKey = (inventorySource) => {
  return `${inventorySource?.inventorySourceType}-${inventorySource?.inventorySourceId || 0}-${inventorySource?.inventorySourceExternalId || 0}`;
};
